<script lang="ts">
import { LevelCommand, levelStore, LevelUp } from "./level";



let level:LevelUp = {
    id: 0,
    totalExperience: 100,
    usedExperiense: 0,
    command: LevelCommand.Save

}

levelStore.set(level)
levelStore.subscribe(l => level = l)


</script>

<button on:click={() => levelStore.set({...level, command: LevelCommand.Start})}>
    Level Up
</button>
<button on:click={() => levelStore.set({
        ...level, 
        command: LevelCommand.Save,
        usedExperiense: 0
    })}>
    Level Save
</button>

<div>{level.usedExperiense} / {level.totalExperience}</div>